import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const coachNeeds = ['More structure.', 'More clarity.', 'Better progressions.', 'A faster way to turn knowledge into coaching.'];
const beforeItems = ['Searching for drills.', 'Saving random videos.', 'Repeating familiar exercises.', 'Building progressions manually.', 'Trying to connect phases.', 'Planning after hours.'];
const withItems = ['Choose the objective.', 'Open the visual system.', 'Set the drill.', 'Follow the progression.', 'Correct the athlete.', 'Coach.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-zinc-100 border-y border-zinc-200" data-id="element-47" data-mp="18m5tmizyzhkh">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-4xl mx-auto text-center" data-id="element-48" data-mp="13nvtrv3avssj">
        <h2 className="text-3xl md:text-4xl font-black uppercase text-zinc-950 mb-6" data-id="element-49" data-mp="24vl8uyr7n4jh">
          MMA coaches don&apos;t need more random information.
        </h2>
        <p className="text-xl text-zinc-600 mb-3" data-id="element-50" data-mp="28weshfxmdx6k">They need:</p>
        <ul className="space-y-1 mb-10" data-id="element-51" data-mp="1v6l3mxm47cwu">
          {coachNeeds.map(need => <li key={need} className="text-xl md:text-2xl font-display font-black uppercase text-violet-900" data-id="element-52" data-mp="204cvjrmrez11">
              {need}
            </li>)}
        </ul>

        <div className="bg-white border border-zinc-200 rounded-2xl p-8 shadow-sm text-lg text-zinc-700 space-y-2 max-w-3xl mx-auto" data-id="element-53" data-mp="1l9yjkb1m4pvv">
          <p data-id="element-54" data-mp="1c7pbdrtth8ln">
            With MMA Coach Ready, you do not have to begin every session from an empty page.
          </p>
          <p className="text-zinc-950 font-semibold" data-id="element-55" data-mp="1h6timcx6kw9c">You already have the framework.</p>
          <p className="text-zinc-950 font-semibold" data-id="element-56" data-mp="36m0102i8k6sh">You already have the progression.</p>
          <p className="text-zinc-950 font-semibold" data-id="element-57" data-mp="3bkb9o9wsob94">You already have the visual coaching tools.</p>
          <p className="text-zinc-950 font-semibold" data-id="element-58" data-mp="395mwrl704n87">
            And with 150 ready-to-coach sessions, you already have the session.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mt-12 text-left" data-id="element-59" data-mp="3565pqnbxfi0x">
          <div className="bg-white border border-zinc-200 rounded-2xl p-6 md:p-8" data-id="element-60" data-mp="30587kaqx2nzf">
            <h3 className="text-lg font-extrabold uppercase text-zinc-500 mb-5" data-id="element-61" data-mp="2v6wzo5k6mnju">
              Before MMA Coach Ready
            </h3>
            <ul className="space-y-3" data-id="element-62" data-mp="3svggdbzkbw1c">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-63" data-mp="3nv2kesb8kcjo">
                  <X size={18} className="text-zinc-400 shrink-0 mt-0.5" aria-hidden="true" data-id="element-64" data-mp="3j2iwp2iu4115" />
                  <span className="text-zinc-600" data-id="element-65" data-mp="3e5997sf09zfy">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-white border-2 border-violet-600 rounded-2xl p-6 md:p-8 shadow-md shadow-violet-900/10" data-id="element-66" data-mp="fg25z14x52ef">
            <h3 className="text-lg font-extrabold uppercase text-violet-600 mb-5" data-id="element-67" data-mp="alo6amj8493y">With MMA Coach Ready</h3>
            <ul className="space-y-3" data-id="element-68" data-mp="i19v4649ivqf">
              {withItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-69" data-mp="n02wx1a6syar">
                  <Check size={18} className="text-green-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-70" data-mp="rw1v1glbhuod" />
                  <span className="text-zinc-950 font-medium" data-id="element-71" data-mp="wx7ojgmsxlyy">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="text-3xl md:text-4xl font-display font-black uppercase text-zinc-950 mt-12" data-id="element-72" data-mp="15wunzwvz0hpd">
          Less planning. <span className="text-violet-600" data-id="element-73" data-mp="1an1b1sau3u5i">More coaching.</span>
        </p>
      </motion.div>
    </section>;
}